<template>
  <div id="app">
    <div id="nav">
      <b-navbar toggleable="lg" type="dark" variant="primary">
        <b-navbar-toggle v-if="isAuthenticated" target="nav_collapse" />
        <b-navbar-brand to="/" exact>
          <!-- eslint-disable-next-line -->
          <img src="/images/logo.png" alt="KeyPlay" />
          <font-awesome-icon icon="home" />
          <!-- eslint-disable-next-line -->
          <span v-html="$t('global.home')" />
        </b-navbar-brand>

        <b-collapse v-if="isAuthenticated" id="nav_collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown id="dropdown-card" variant="primary" :text="$t('Navbar.operations')" class="m-md-1"
              right>
              <b-dropdown-item to="/operations_periodical">
                {{ $t("Navbar.operations_periodical") }}
              </b-dropdown-item>
              <b-dropdown-item to="/operations_daily">
                {{ $t("Navbar.operations_daily") }}
              </b-dropdown-item>
              <b-dropdown-item to="/operations_hourly">
                {{ $t("Navbar.operations_hourly") }}
              </b-dropdown-item>
              <b-dropdown-item to="/operations_compare">
                {{ $t("Navbar.operations_compare") }}
              </b-dropdown-item>
              <b-dropdown-item to="/accounting">
                {{ $t("Navbar.accounting") }}
              </b-dropdown-item>
              <b-dropdown-item to="/smart_touch_maintenance">
                {{ $t("Navbar.smart_touch_maintenance") }}
              </b-dropdown-item>
              <b-dropdown-item to="/operations_expired">
                {{ $t("Navbar.operations_expired") }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown id="dropdown-events" variant="primary" :text="$t('Navbar.events')" class="m-md-1"
              right>
              <b-dropdown-item to="/events_accounting">
                {{ $t("Navbar.events_accounting") }}
              </b-dropdown-item>
              <b-dropdown-item to="/business_events_order">
                {{ $t("Navbar.business_events_order") }}
              </b-dropdown-item>
              <b-dropdown-item to="/business_events_order_simple">
                {{ $t("Navbar.business_events_order_simple") }}
              </b-dropdown-item>
              <b-dropdown-item to="/business_events_presta">
                {{ $t("Navbar.business_events_presta") }}
              </b-dropdown-item>
              <b-dropdown-item to="/business_events_presta_simple">
                {{ $t("Navbar.business_events_presta_simple") }}
              </b-dropdown-item>
              <b-dropdown-item to="/cake">
                {{ $t("Navbar.cake") }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown id="dropdown-card" variant="primary" :text="$t('Navbar.kiosks')" class="m-md-1" right>
              <b-dropdown-item to="/kiosk_global">
                {{ $t("Navbar.kiosk_global") }}
              </b-dropdown-item>
              <b-dropdown-item to="/kiosk_global_Updated">
                {{ $t("Navbar.kiosk_global_Updated") }}
              </b-dropdown-item>
              <b-dropdown-item to="/kiosk_compare">
                {{ $t("Navbar.kiosk_compare") }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown id="dropdown-card" variant="primary" :text="$t('Navbar.menu_games')" class="m-md-1"
              right>
              <b-dropdown-item to="/games">
                {{ $t("Navbar.games") }}
              </b-dropdown-item>
              <b-dropdown-item to="/games_code">
                {{ $t("Navbar.games_code") }}
              </b-dropdown-item>
              <b-dropdown-item to="/games_simple">
                {{ $t("Navbar.games_simple") }}
              </b-dropdown-item>
              <b-dropdown-item to="/games_compare">
                {{ $t("Navbar.games_compare") }}
              </b-dropdown-item>
              <b-dropdown-item to="/staff">
                {{ $t("Navbar.staff") }}
              </b-dropdown-item>
              <b-dropdown-item to="/staff_history">
                {{ $t("Navbar.staffHistory") }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown variant="primary" :text="$t('Navbar.domains')" class="m-md-1" right>
              <b-dropdown-item to="/snacking">
                {{ $t("Navbar.snacking") }}
              </b-dropdown-item>
              <b-dropdown-item to="/merchandising">
                {{ $t("Navbar.merchandising") }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>

          <b-navbar-nav>
            <b-nav-item-dropdown variant="primary" :text="$t('Navbar.stats')" class="m-md-1" right>
              <b-dropdown-item to="/cards">
                {{ $t("Navbar.cards") }}
              </b-dropdown-item>
              <b-dropdown-item to="/onmniplay_report">
                {{ $t("Navbar.onmniplay_report") }}
              </b-dropdown-item>
              <b-dropdown-item to="/consumption_report">
                {{ $t("Navbar.consumption_report") }}
              </b-dropdown-item>
              <b-dropdown-item to="/azure_cost">
                {{ $t("Navbar.azure_cost") }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown :text="username" right>
              <b-dropdown-item to="/subscriptions">{{
                $t("Navbar.subscription")
              }}</b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item @click="signOut">
                {{ $t("Navbar.signout") }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    boGlobalUrl() {
      return `${window.VUE_APP_GLOBAL_URL}/release-notes`
    }
  },
  methods: {
    signOut() {
      // redirect on the login page
      this.$store.dispatch("authentication/logout");

      //  trigger an event on every tab
      localStorage.setItem("logout", "");
      localStorage.removeItem("logout");
    },
    isAdminMba() {
      const roleRank = this.$store.getters["authentication/getRoleRank"];
      return roleRank <= 1;
    },
  },
};
</script>
<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "~bootstrap-vue/src/index.scss";
@import "./scss/main.scss";
</style>
